import { Button, Form, Input, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import regex from '../../constants/system.keys';
import * as SERVICE from '../../constants/service.types';
import { useDispatch, useSelector } from 'react-redux';
import { socketEmitEvent } from '../../redux/actions';

const ChangePassword = ({
  openModalChangePassword,
  setOpenModalChangePassword,
}) => {
  const { namespace } = useSelector((state) => state);
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const handleChangePassword = (values) => {
    const requestId = new Date().getTime();
    const data = {
      oldPassword: values.passwordCurrent,
      newPassword: values.newPassword,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.CHANGE_USER_PASSWORD,
      requestId,
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setOpenModalChangePassword(false);
  };
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={t('Change password')}
      visible={openModalChangePassword}
      onCancel={() => {
        setOpenModalChangePassword(false);
      }}
      footer={null}
    >
      <Form
        form={form}
        {...layout}
        name="form_change_password"
        onFinish={(values) => {
          console.log('submit');
          handleChangePassword(values);
        }}
      >
        <Form.Item
          name="passwordCurrent"
          label={t('Password Current')}
          rules={[
            {
              required: true,
              message: t('Please input the password current!'),
            },

            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label={t('New Password')}
          rules={[
            {
              required: true,
              message: t('Please input the new password!'),
            },
            {
              pattern: regex.isPasswordStrong,
              message: t('The password you entered is not strong enough!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label={t('Confirm Password')}
          rules={[
            {
              required: true,
              message: t('Please input the confirm password!'),
            },
            {
              pattern: regex.isPasswordStrong,
              message: t('The password you entered is not strong enough!'),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(t('The passwords do not match!'))
                );
              },
            }),
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item style={{ textAlign: 'right', marginTop: '16px' }}>
          <Button type="primary" htmlType="submit">
            {t('Change password')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePassword;
